<template>

<span>

    <b-row>
        <b-col>
            <b-jumbotron class="mt-3">
                
                <template v-slot:header>
                    Principal Task
                </template>

                <template v-slot:lead>
                    
                    Everyone has 24 hours in a day.  Do more with yours.

                </template>

                <hr class="my-4">

                <p>
                It uses utility classes for typography and spacing to space content out within the larger
                container.
                </p>

                <b-button variant="primary" href="#">Do Something</b-button>
                <b-button variant="success" href="#">Do Something Else</b-button>
            </b-jumbotron>
        </b-col>
    </b-row>

</span>

</template>

<script>

import Menu from '@/components/Menu.vue'

export default {

    name: 'DoMore',
    components: {
        Menu
    },

}
</script>
